import React from "react";
import { Flex, Stack, Text, Icon, IconButton, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { MdGavel, MdAdd, MdRefresh } from "react-icons/md";

/**
 * Renders the add and refresh action buttons for the list header.
 * @param {object} props
 * @param {boolean} props.refreshing - Whether a refresh is in progress
 * @param {function} props.onRefresh - Callback to refresh
 * @param {function} props.onNewDocument - Callback to create new document
 * @returns {React.ReactElement}
 */
function ListHeaderActions({ refreshing, onRefresh, onNewDocument }) {
    return (
        <Stack direction="row" spacing="4px">
            <Tooltip label="New document">
                <IconButton aria-label="Nouveau document" size="sm" colorScheme="green" variant="outline"
                    borderRadius="10px" icon={<Icon as={MdAdd} />} onClick={onNewDocument} />
            </Tooltip>
            <Tooltip label="Refresh">
                <IconButton aria-label="Recharger" size="sm" variant="outline" borderRadius="10px"
                    isLoading={refreshing} icon={<Icon as={MdRefresh} />} onClick={onRefresh} />
            </Tooltip>
        </Stack>
    );
}

/**
 * Renders the header bar of the legal document list with title icon,
 * new document button, and refresh button.
 * @param {object} props
 * @param {boolean} props.refreshing - Whether a refresh is in progress
 * @param {function} props.onRefresh - Callback to refresh the document list
 * @param {function} props.onNewDocument - Callback to create a new document
 * @returns {React.ReactElement}
 */
function ListHeader({ refreshing, onRefresh, onNewDocument }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    return (
        <Flex justify="space-between" align="center" mb="16px">
            <Stack direction="row" spacing="10px" align="center">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
                    <Icon as={MdGavel} color="brand.500" boxSize="22px" />
                </Flex>
                <Text fontWeight="700" fontSize="1rem" color={titleColor}>Documents légaux</Text>
            </Stack>
            <ListHeaderActions refreshing={refreshing} onRefresh={onRefresh} onNewDocument={onNewDocument} />
        </Flex>
    );
}

export default ListHeader;
